module.exports = __webpack_public_path__ + "img/Liquitty_Negro_SinFondo.fe6a6c3e.png";